import { render, staticRenderFns } from "./cardTrialDetail.vue?vue&type=template&id=c66bb50e&scoped=true&"
import script from "./cardTrialDetail.vue?vue&type=script&lang=js&"
export * from "./cardTrialDetail.vue?vue&type=script&lang=js&"
import style0 from "./cardTrialDetail.vue?vue&type=style&index=0&id=c66bb50e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66bb50e",
  null
  
)

export default component.exports